import { useState, useEffect } from 'react';

const useDimensions = (
    ref,
    hideFilters
) => {
    
    const   svgHeight = ref && ref.getBoundingClientRect().height,
            svgWidth = ref && ref.getBoundingClientRect().width
    const   [ firstRender, setFirstRender ] = useState(true),
            [ resizing, setResizing ] = useState(false),
            [ width, setWidth ] = useState(0),
            [ height, setHeight ] = useState(0)
    
    const resizingListener = () => setResizing(true)

    useEffect(() => {
        if(firstRender){
            window.addEventListener("resize", () => resizingListener())
            setFirstRender(false)
        }
    }, [firstRender])

    useEffect(() => {
        svgWidth !== width && setWidth(svgWidth)
        svgHeight !== height && setHeight(svgHeight)
        setResizing(false)
    }, [ resizing, svgWidth, svgHeight, height, width ])

    useEffect(() =>{ 
        let timer1 = setTimeout(() => setResizing(true), 500)
    }, [hideFilters])
    
    return { width, height }
}

export default useDimensions